import {Component, effect, inject, OnInit} from '@angular/core';
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Location, NgClass} from "@angular/common";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {appVersion} from "src/app/app-info";
import {environment} from "src/app/environments/environment";
import {DataStorageService, KeyValuePairEntity} from "src/app/infrastructure/data-storage.service";
import {DeviceApiClient} from "src/app/infrastructure/moovement-api/web-api/device.api-client";
import {Animal, DeviceAssociation} from "src/app/infrastructure/moovement-api/models/asset";
import {UserAgent} from "src/app/infrastructure/moovement-api/models/user";
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {DataType} from 'src/app/domain/domain-models';
import {DeviceStore} from 'src/app/domain/devices/device.store';
import {DeviceAssociationStore} from 'src/app/domain/devices/device-association.store';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';

@Component({
  selector: 'app-developer-console',
  imports: [
    GenericButtonComponent,
    NgClass
  ],
  templateUrl: './developer-console.component.html',
  styleUrl: './developer-console.component.css'
})
export class DeveloperConsoleComponent implements OnInit {

  protected notificationToken?: string
  protected currentFilter?: string
  protected showKeyValuePairs: boolean = false
  protected showAnimals: boolean = false
  protected showDeviceAssociations: boolean = false
  protected assetRows: Animal[] = []
  protected keyValuePairs: KeyValuePairEntity[] = []
  protected valuesToIgnore: string[] = []
  protected deviceAssociations: DeviceAssociation[] = []
  protected readonly appVersion = appVersion;
  protected readonly environment = environment;

  deviceAssociationStore = inject(DeviceAssociationStore);

  private deviceStore = inject(DeviceStore);
  private farmStore = inject(FarmStore);
  private location = inject(Location);
  private mainViewStore = inject(MainViewStore);

  constructor(
    private dataStorageService: DataStorageService,
    private deviceApiClient: DeviceApiClient,
    private dataSubscriptionService: DataSubscriptionService,
    protected viewportService: ViewportService
  ) {
    effect(() => {
      if (this.deviceStore.loading()) return;

      this.loadDeviceAssociations();
    });
  }

  ngOnInit(): void {
    const farm = this.farmStore.farm();
    if (!farm) return;

    this.dataStorageService.getAssetsDump<Animal>(DataType.animals, farm.id).then(animals => {
      this.assetRows = animals;
    });
    this.dataStorageService.getAssetsDump<Animal>(DataType.animals, farm.id).then(animals => {
      this.assetRows = animals;
    });
    this.dataStorageService.getKeyValuePairsDump().then(keyPairs => {
      this.keyValuePairs = keyPairs;
    });

    this.dataStorageService.getValueByKey<UserAgent>('userAgent').then(userAgent => {
      this.notificationToken = userAgent?.notificationId
    });
  }

  onToggleAnimals() {
    this.showAnimals = !this.showAnimals;
  }

  onToggleDeviceAssocations() {
    this.showDeviceAssociations = !this.showDeviceAssociations;
  }

  onResetNotificationToken() {
    this.dataSubscriptionService.publish('refreshNotificationToken', "")
  }

  backToApp() {
    this.location.back()
  }

  loadDeviceAssociations() {
    const devices = this.deviceStore.entities();

    const deviceIds = devices.map(device => device.id)
    this.deviceApiClient.getDeviceAssociations(deviceIds).subscribe(deviceAssociations => {
      this.deviceAssociations = deviceAssociations.filter(d => d.endDateTime === undefined)
    });
  }

  onToggleKeyValuePairs() {
    this.showKeyValuePairs = !this.showKeyValuePairs
  }

  back(): void {
    this.location.back();
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }
}
